import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import default fallback images
import img1 from "../assets/images/blog/grid/1.webp";
import img2 from "../assets/images/blog/grid/2.webp";
import img3 from "../assets/images/blog/grid/3.webp";
import img4 from "../assets/images/blog/grid/4.webp";
import img5 from "../assets/images/blog/grid/5.webp";
import img6 from "../assets/images/blog/grid/6.webp";

const BlogSlider = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get API configuration
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";

  // Default fallback blog images
  const fallbackImages = [img1, img2, img3, img4, img5, img6];

  // Default static blog posts (fallback)
  const defaultBlogPosts = [
    {
      blog_id: 1,
      blog_image_url: img1,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 2,
      blog_image_url: img2,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 3,
      blog_image_url: img3,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 4,
      blog_image_url: img4,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 5,
      blog_image_url: img5,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
    {
      blog_id: 6,
      blog_image_url: img6,
      blog_tags: "Business, Consumers",
      blog_title:
        "Empowered consumers are prepared to make changes response to disruptions!",
      blog_short_txt:
        "Global uncertainties and supply chain issues are also leading many consumers to look more to their home markets. Eight in ten respondents expressed a willingness to pay a higher average price for products produced locally or domestically.",
      c_date: "2025-01-30",
    },
  ];

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      setError(null);

      const formData = new FormData();
      formData.append("company_id", "1");
      formData.append("employee_id", "1");
      formData.append("type", "1"); // Type 1 for show all blogs

      const response = await fetch(`${api_url}blog.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1" && data.result && data.result.length > 0) {
        setBlogs(data.result);
      } else {
        // Use default blogs if no data found
        setBlogs(defaultBlogPosts);
      }
    } catch (err) {
      console.error("Error fetching blogs:", err);
      setError("Failed to load blogs");
      // Use default blogs on error
      setBlogs(defaultBlogPosts);
    } finally {
      setLoading(false);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "Jan 30, 2025";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Parse categories from blog_tags
  const parseCategories = (tags) => {
    if (!tags) return ["Business", "Consumers"];
    return tags.split(",").map((tag) => tag.trim());
  };

  // Use API blogs if available, otherwise use default
  const displayBlogs = blogs.length > 0 ? blogs : defaultBlogPosts;

  return (
    <section className="blog-layout1 blog-slider section-full-width overflow-slider overflow-x-hidden pb-90">
      <div className="container">
        <div className="row mb-40">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="heading-layout2">
              <h3 className="heading-title">News & Articles</h3>
            </div>
            {/* /.heading */}
          </div>
          {/* /.col-lg-6 */}
          <div className="col-sm-12 col-md-12 col-lg-6 d-flex align-items-center justify-content-lg-end gap-50">
            <div className="d-flex">
              <div
                id="article-next"
                className="swiper-button-prev-2 icon-arrow-left position-static"
              ></div>
              <div
                id="article-prev"
                className="swiper-button-next-2 icon-arrow-right position-static"
              ></div>
            </div>
          </div>
          {/* /.col-lg-6 */}
        </div>
        {/* /.row */}
        <div className="row">
          <div className="col-12">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Loading blogs...</p>
              </div>
            ) : (
              <Swiper
                slidesPerView={1}
                spaceBetween={20}
                loop={true}
                watchSlidesProgress={true}
                autoplay={{
                  delay: 6000,
                  disableOnInteraction: false,
                }}
                navigation={{
                  nextEl: "#article-next",
                  prevEl: "#article-prev",
                }}
                breakpoints={{
                  550: {
                    slidesPerView: 2,
                  },
                  992: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: 4,
                  },
                }}
                modules={[Navigation, Autoplay]}
                className="swiper"
              >
                <div className="swiper-wrapper">
                  {displayBlogs.map((post, index) => (
                    <SwiperSlide key={post.blog_id}>
                      {/* Post Item */}
                      <article className="post-item">
                        <div className="post-img">
                          <Link to={`/blogDetails/${post.blog_id}`}>
                            <img
                              src={post.blog_image_url}
                              alt={post.blog_title}
                              loading="lazy"
                              onError={(e) => {
                                // Fallback to default image if API image fails
                                e.target.src =
                                  fallbackImages[index % fallbackImages.length];
                              }}
                            />
                          </Link>
                        </div>
                        {/* /.post-img */}
                        <div className="post-body">
                          <div className="post-meta-cat">
                            {parseCategories(post.blog_tags).map(
                              (category, catIndex) => (
                                <Link to="#" key={catIndex}>
                                  {category}
                                </Link>
                              )
                            )}
                          </div>
                          {/* /.blog-meta-cat */}
                          <div className="post-text">
                            <h4 className="post-title mb-0">
                              <Link to={`/blogDetails/${post.blog_id}`}>
                                {post.blog_title || "Untitled Blog Post"}
                              </Link>
                            </h4>
                            <p className="post-desc text-truncate-6 mb-0">
                              {post.blog_short_txt ||
                                "No description available for this blog post."}
                            </p>
                          </div>
                          {/* /.post-text */}
                          <span className="post-meta-date">
                            {formatDate(post.c_date)}
                          </span>
                        </div>
                        {/* /.post-body */}
                        <div className="post-footer">
                          <Link
                            to={`/blogDetails/${post.blog_id}`}
                            className="btn btn-white"
                          >
                            <i className="icon-arrow-up-right"></i>
                          </Link>
                        </div>
                        {/* /.post-footer */}
                      </article>
                      {/* /.post-item */}
                    </SwiperSlide>
                  ))}
                </div>
                {/* /.swiper */}
              </Swiper>
            )}
            {/* /.swiper */}
          </div>
          {/* /.col-12 */}
        </div>
        {/* /.row */}
        <div className="row">
          <div className="col-12 text-center">
            <Link
              to="/blogs"
              className="btn btn-secondary btn-link btn-underlined arrow-hover-flip-up"
            >
              <span>Check All Blog Posts</span>
              <svg
                className="arrow-flip"
                enableBackground="new 0 0 64 64"
                viewBox="0 0 64 64"
                width="10"
                height="10"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g className="arrow-flip-path-1">
                  <path
                    d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                    fill="currentColor"
                  ></path>
                </g>
                <g className="arrow-flip-path-2">
                  <path
                    d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                    fill="currentColor"
                  ></path>
                </g>
              </svg>
            </Link>
          </div>
          {/* /.col-12 */}
        </div>
        {/* /.row */}
      </div>
      {/* /.container */}
    </section>
  );
};

export default BlogSlider;
